import { connect } from 'react-redux';

import Component from '../../common/components/js/ranking/Ranking';
import { ITopStates } from '../store';

const mapStateToProps = (state: ITopStates) => ({
  title: state.zasshiRanking.title,
  url: state.zasshiRanking.url,
  list: state.zasshiRanking.list,
  isError: state.zasshiRanking === undefined,
  ultSec: 'zaccr',
  yadsDs: '90113_265662',
  categoryId: state.pageData.yads.categoryId
});

export default connect(mapStateToProps, {})(Component);
